<template>
    <v-flex v-if="match" xs12>
      <confirm-modal
        :dialog="showConfirm"
        :message="confirmMessage"
        @confirm="confirmResponse($event)">
      </confirm-modal>
        <v-card class="match mb-3">
            <v-tooltip top class="tooltip-reset">
              <v-btn
                  @click="deleteResult($event)"
                  icon
                   color="red"
                    slot="activator"
                    dark
                    small
                    fab>
                <v-icon>autorenew</v-icon>
              </v-btn>
              <span>Reiniciar marcador</span>
            </v-tooltip>
            
          <!-- TEAM-A -->
          <div class="match-team team-a hover"
            v-bind:class="{ 'selected':  selectedTeam === match.team_a_obj.id }"
            @click="setSelectedPlayers(teamAPlayers, match.team_a_obj.id)">
            <p class="match-team__label full-width">
              <!-- team name -->
              <span class="crop-text">{{ match.team_a_obj.name }}</span>
            </p>

            <!-- team image -->
            <div class="match-team__img"
              :style="{'background': 'transparent url('+ match.team_a_obj.image.original +') center/cover no-repeat'}">
            </div>
          </div>

          <!-- MATCH SCORE -->
          <div class="match-score pa-1">
            <span class="match-score__item"
              @click="setSelectedPlayers(teamAPlayers, match.team_a_obj.id)" v-if="!selectedPlayers">
              {{ defaultResults ? '-' : teamAGoals }}
            </span>

            <vue-numeric class="match-score__item"
              :min="sumPlayersAGoals"
              :max="50"
              separator=""
              v-if="selectedPlayers"
              :read-only="selectedPlayers ? false : true"
              v-model="teamAGoals">
            </vue-numeric>

            <span class="match-score__divider">:</span>

            <span class="match-score__item"
              @click="setSelectedPlayers(teamBPlayers, match.team_b_obj.id)" v-if="!selectedPlayers">
              {{ defaultResults ? '-' : teamBGoals }}
            </span>

            <vue-numeric class="match-score__item"
              :min="sumPlayersBGoals"
              :max="50"
              separator=""
              v-if="selectedPlayers"
              :read-only="selectedPlayers ? false : true"
              v-model="teamBGoals">
            </vue-numeric>
          </div>

          <!-- TEAM-B -->
          <div class="match-team team-b hover"
            v-bind:class="{ 'selected':  selectedTeam === match.team_b_obj.id }"
            @click="setSelectedPlayers(teamBPlayers, match.team_b_obj.id)">
            <!-- team image -->
            <div class="match-team__img"
              :style="{'background': 'transparent url('+ match.team_b_obj.image.original +') center/cover no-repeat'}">
            </div>

            <p class="match-team__label full-width">
              <!-- team name -->
              <span class="crop-text">{{ match.team_b_obj.name }}</span>
            </p>
          </div>

          <!-- MATCH FOOTER -->
          <div class="match-footer">
            <!-- match address -->
            <v-tooltip top>
              <p class="match-address"
                slot="activator">
                <v-icon class="mr-1">location_on</v-icon>
                <span class="green--text">{{ match.court_obj.name }}</span>
              </p>
              <span>{{ match.court_obj.address }}</span>
            </v-tooltip>

            <!-- match date -->
            <p class="match-date ma-0">
              <v-icon class="mr-1">event</v-icon>
              {{ matchDate }}
            </p>
          </div>

          <!-- previous code -->
          <!-- <v-card-text>
              <v-container fluid>
                  <v-layout row wrap>
                      <v-flex  xs12 text-xs-left mb-1>
                          <v-icon class="mr-2">location_on</v-icon>
                          <span  class="green--text subheading">{{match.court_obj.name}}</span>
                          <span class="subheading">{{match.court_obj.address}}</span>
                      </v-flex>
                      <v-flex xs12 text-xs-left>
                          <v-icon class="mr-2">event</v-icon>
                          <span class="subheading">{{matchDate}}</span>
                      </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                      <v-flex xs12 sm5>
                          <v-card light>
                              <v-card-text :style="{ 'display': 'flex', 'align-items': 'center' }">
                                  <div
                                        @click="setSelectedPlayers(teamAPlayers)"
                                      class="fab-img"
                                      :style="{'background-image': 'url('+match.team_a_obj.image.original+')'}"
                                  ></div>
                                  <span @click="setSelectedPlayers(teamAPlayers)" class="pl-2">{{match.team_a_obj.name}}</span>
                              </v-card-text>
                          </v-card>
                      </v-flex>
                      <v-flex xs12 sm2 d-flex align-center justify-center headline>
                          <v-flex xs12 sm3 d-flex align-center justify-center headline>
                            <span @click="setSelectedPlayers(teamAPlayers)" v-if="!selectedPlayers"  class="score-text">
                              {{defaultResults ? '-' : teamAGoals}}
                            </span>
                            <vue-numeric
                            class="score-text"
                              :min="sumPlayersAGoals"
                              :max="50"
                              separator=""
                              v-if="selectedPlayers"
                              :read-only="selectedPlayers ? false : true"
                              v-model="teamAGoals"></vue-numeric>

                          </v-flex>
                          <v-flex xs12 sm4 d-flex align-center justify-center headline>VS</v-flex>

                          <v-flex xs12 sm3 d-flex align-center justify-center headline>
                            <span @click="setSelectedPlayers(teamBPlayers)" v-if="!selectedPlayers"  class="score-text">
                              {{defaultResults ? '-' : teamBGoals}}
                            </span>
                            <vue-numeric
                            class="score-text"
                              :min="sumPlayersBGoals"
                              :max="50"
                              separator=""
                              v-if="selectedPlayers"
                              :read-only="selectedPlayers ? false : true"
                              v-model="teamBGoals"></vue-numeric>

                          </v-flex>
                      </v-flex>
                      <v-flex xs12 sm5>
                          <v-card light>
                              <v-card-text :style="{ 'display': 'flex', 'align-items': 'center' }">
                                  <div
                                  @click="setSelectedPlayers(teamBPlayers)"
                                      class="fab-img"
                                      :style="{'background-image': 'url('+match.team_b_obj.image.original+')'}"
                                  ></div>
                                  <span @click="setSelectedPlayers(teamBPlayers)" class="pl-2">{{match.team_b_obj.name}}</span>
                              </v-card-text>
                          </v-card>
                      </v-flex>
                  </v-layout>
              </v-container>
          </v-card-text> -->
        </v-card>

        <v-card class="pa-3" v-if="selectedPlayers" light>
            <h4 class="pt-3" style="text-align:center; width: 100%">{{selectedTeamName}}</h4>

          <v-data-table
              :rows-per-page-items="[25,50,100]"
              v-if="selectedPlayers"
              :headers="headers"
              :items="selectedPlayers"
              hide-actions
              light
              class="elevation-1 responsive-table scoring-table">
              <template slot="items" slot-scope="props">
                  <td>{{ props.item.name }}</td>
                  <td class="text-xs-right">
                      <div class="horizontal-flex">
                          <v-btn @click="addPlayerGoal(props.item)" color="green" fab flat small>
                              <v-icon color="green">add</v-icon>
                          </v-btn>
                          <span class="table-statistic">{{props.item.gol}}</span>
                          <v-btn @click="removePlayerGoal(props.item)" color="red" fab flat small>
                              <v-icon color="red">remove</v-icon>
                          </v-btn>
                      </div>
                  </td>
                  <td class="text-xs-right">
                      <v-checkbox
                        v-model="props.item.real_going"
                        :disabled="props.item.yellow_cards > 0 || props.item.red_cards > 0 || props.item.gol > 0"
                        light></v-checkbox>
                  </td>
                  <td class="text-xs-right">
                      <div class="horizontal-flex">
                          <v-btn @click="addPlayerYellowCard(props.item)" color="green" fab flat small>
                              <v-icon  color="green">add</v-icon>
                          </v-btn>
                          <span class="table-statistic yellow">{{props.item.yellow_cards}}</span>
                          <v-btn @click="removePlayerYellowCard(props.item)" color="red" fab flat small>
                              <v-icon color="red">remove</v-icon>
                          </v-btn>
                      </div>
                  </td>
                  <td class="text-xs-right">
                      <div class="horizontal-flex">
                          <v-btn @click="addPlayerRedCard(props.item)" color="green" fab flat small>
                              <v-icon color="green">add</v-icon>
                          </v-btn>
                          <span class="table-statistic red">{{props.item.red_cards}}</span>
                          <v-btn @click="removePlayerRedCard(props.item)" color="red" fab flat small>
                              <v-icon color="red">remove</v-icon>
                          </v-btn>
                      </div>
                  </td>
              </template>
          </v-data-table>

          <v-container v-if="showPenaltiesQuestion" fluid>
            <v-layout row wrap>
              <v-flex xs3 text-xs-left offset-sm9>
                ¿Quien ganó en los penales?
              </v-flex>
              <v-flex xs3 text-xs-right offset-sm9>
                <v-radio-group v-model="drawWinnerTeamId" light>
                  <v-radio
                    :key="match.team_a_obj.id"
                    :label="match.team_a_obj.name"
                    :value="match.team_a_obj.id"
                    light>
                  </v-radio>
                  <v-radio
                    :key="match.team_b_obj.id"
                    :label="match.team_b_obj.name"
                    :value="match.team_b_obj.id"
                    light>
                  </v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-container>

          <v-card-actions class="py-3">
            <v-spacer></v-spacer>
            <v-btn @click="cancel()" >Cancelar</v-btn>
            <v-btn @click="save()" >Guardar</v-btn>
          </v-card-actions>
        </v-card>
    </v-flex>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import VueNumeric from 'vue-numeric'
import Match from '@/models/match'
import moment from 'moment'
export default {
  name: "MatchRow",
  components: {
    VueNumeric
  },
  props: {
    match:{required:true, default:null},
    tournamentid:{required:true},
    disabled:{default:false}
  },
  data: () => ({
    selectedTeam: null,
    drawWinnerTeamId:null,
    cbTest:false,
    teamAGoals:0,
    teamBGoals:0,
    teamAPlayers:[],
    teamBPlayers:[],
    defaultResults: true,
    selectedPlayers: null,
    selectedTeamName: "",
    headers: [
        { text: 'Nombre', value: 'name', align: 'left' },
        { text: 'Goles', value: 'goals', align: 'left' },
        { text: 'Asistencia', value: 'attendans', align: 'left' },
        { text: 'Tarjetas Amarillas', value: 'yellowCards', align: 'left' },
        { text: 'Tarjetas Rojas (mg)', value: 'redCards', align: 'left' }
    ],
    showConfirm: false,
    confirmMessage: '¿Estas seguro que quieres reiniciar el marcador?',
  }),
  created() {
    //do something after creating vue instance
    console.log("AQUI",this.currentTournament)
    this.copyMatch()
  },
  watch:{
    match(match){
      console.log("WATCH_MATCH",match)
      this.selectedPlayers = null
      this.copyMatch()
    },
    teamAGoals(g){
      let playersGoals = this.sumPlayersAGoals
      if(g < playersGoals){
        this.teamAGoals = playersGoals
      }
    },
    teamBGoals(g){

      let playersGoals = this.sumPlayersBGoals
      console.log("WATCHB",g,playersGoals)
      if(g < playersGoals){
        this.teamBGoals = playersGoals
      }
    }
  },
  computed:{
    matchDate(){
      if(this.match.date){
        var localLocale = moment(this.match.date);
        moment.locale('es');
        localLocale.locale(false);
        return localLocale.format('MMMM DD [del] YYYY [a] hh:mm a')
      }
    },
    sumPlayersAGoals(){
      if(!this.match){return 0}
      var result = 0
      for(var i in this.teamAPlayers){
        result += this.teamAPlayers[i].gol
      }
      return result
    },
    sumPlayersBGoals(){
      if(!this.match){return 0}
      var result = 0
      for(var i in this.teamBPlayers){
        result += this.teamBPlayers[i].gol
      }
      return result
    },
    showPenaltiesQuestion(){
      if(this.currentTournament.penalties && this.teamAGoals == this.teamBGoals){
        return true
      }
      this.drawWinnerTeamId = null
      return false
    },
    ...mapGetters([
      'currentTournament'
    ])
  },
  methods: {
    ...mapActions([
      'captureMatchResult',
      'resetMatchResult'
    ]),
    formatDate(date){
      var localLocale = moment(date);
      moment.locale('es');
      localLocale.locale(false);
      return localLocale.format('LLLL')
    },
    copyMatch(){
      this.teamAPlayers = JSON.parse(JSON.stringify(this.match.result.team_a_players))
      this.teamBPlayers = JSON.parse(JSON.stringify(this.match.result.team_b_players))
      this.teamBGoals = this.match.result.team_b_gol
      this.teamAGoals = this.match.result.team_a_gol
      this.defaultResults = this.match.result.default
      this.drawWinnerTeamId = this.match.result.draw_winner_team_id
    },
    cancel() {
      this.selectedTeam = null
      this.selectedPlayers = null
      this.copyMatch()
    },
    save(){
      this.selectedTeam = null
      let match = {
        id : this.match.id,
        result:{
          team_a_players: this.teamAPlayers,
          team_b_players: this.teamBPlayers,
          team_a_gol: this.teamAGoals,
          team_b_gol: this.teamBGoals,
          winner_team: this.showPenaltiesQuestion ? this.drawWinnerTeamId : null
        }
      }

      this.captureMatchResult({tournamentid:this.tournamentid,match:match})
    },
    resetResult() {
      let data = {
        tournamentId: this.tournamentid,
        match: this.match
      }

      console.log("aqui la dataaaa:", data);

      this.resetMatchResult(data);
    },
    deleteResult(event) {
      this.showConfirm = true
    },
    confirmResponse(response) {
      if(response){
        //En caso la respuesta del usuario sea positiva
        this.resetResult();
      }
      this.showConfirm = false
    },
    addPlayerYellowCard(player){
      player.yellow_cards+=1
      player.real_going = true
    },
    removePlayerYellowCard(player){
      if(player.yellow_cards<=0){return}
      player.yellow_cards-=1
    },
    addPlayerRedCard(player){
      player.red_cards+=1
      player.real_going = true
    },
    removePlayerRedCard(player){
      if(player.red_cards<=0){return}
      player.red_cards-=1
    },
    addPlayerGoal(player){
      player.gol+=1
      this.recalculeGoals()
      player.real_going = true
    },
    removePlayerGoal(player){
      if(player.gol<=0){return}
      player.gol-=1
      this.recalculeGoals()
    },
    setSelectedPlayers(players, team){
      this.selectedTeam = team;
      if(this.disabled){return}
      console.log("setSelectedPlayers",players)
      this.selectedPlayers = players
      if(players == this.teamAPlayers){
        this.selectedTeamName = this.match.team_a_obj.name
      }else{
        this.selectedTeamName = this.match.team_b_obj.name
      }
    },
    recalculeGoals(){
      if(!this.selectedPlayers) return
      if(this.selectedPlayers == this.teamAPlayers){
        let playersGoals = this.sumPlayersAGoals
        if(playersGoals > this.teamAGoals){
          this.teamAGoals = playersGoals
        }
      }else{
        let playersGoals = this.sumPlayersBGoals
        if(playersGoals > this.teamBGoals){
          this.teamBGoals = playersGoals
        }
      }
    }
  }
}
</script>
<style lang="css" scoped>
.table-statistic {
  border-radius: 50%;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px;
  font-size: 14px;
}

.horizontal-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* matches */
.match-team {
  cursor: pointer;
}
.match-team.team-a {
  padding: 5px 5px 5px 0;
}
.match-team.team-b {
  padding: 5px 0 5px 5px;
}

span.match-score__item {
  cursor: pointer;
}

/* table */
table.table tbody td:first-child,
table.table tbody td:not(:first-child) {
  padding: 0 10px;
}

.scoring-table .btn {
  margin: 0;
  height: 30px;
  width: 30px;
}

.tooltip-reset {
  position: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/scores/MatchRow.vue